import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { hlm } from 'app/core/utils/hlm';
import { ClassValue } from 'clsx';

@Component({
  selector: 'sheba-arrow-start-icon',
  templateUrl: 'arrow-start.svg',
  host: {
    '[class]': 'computedClass()'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArrowStartIcon {
  readonly userClass = input<ClassValue>('', { alias: 'class' });
  readonly computedClass = computed(() => hlm('block ltr:rotate-180 text-[#161F72]', this.userClass()));
}
